import React, { useState } from 'react';

const OfflineNotice = () => {
  const [offline, setOffline] = useState(!navigator.onLine);
  const updateOnlineStatus = () => {
    setOffline(!navigator.onLine);
  };
  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
  return (
    <div className="bhp-update-notice">
      <div className="bhp-banner">
        {offline && (
          <span>
            <b>&#9888;&nbsp;Internet disconnected. </b>
            You appear to be offline. Functionality may be limited.
          </span>
        )}
      </div>
    </div>
  );
};

export default OfflineNotice;
